import { IGlobalAlert } from 'domain/globalAlerts/types';
import { createAsyncAction, createStandardAction } from 'typesafe-actions';

export const globalAlertsActions = createAsyncAction(
  'GLOBAL_ALERTS_REQUEST',
  'GLOBAL_ALERTS_SUCCESS',
  'GLOBAL_ALERTS_FAILURE'
)<void, { alerts: IGlobalAlert[] }, Error>();

export const globalAlertsDismissAction = createStandardAction('GLOBAL_ALERTS_DISMISS')<{
  id: number;
}>();
